import React, { useState } from 'react';
import { Key, Lock, ArrowRight, AlertCircle } from 'lucide-react';

const LICENSE_KEY = 'SHOP-SETUP-UNIK-FRON';

function SetupLicense({ onVerified }) {
  const [licenseKey, setLicenseKey] = useState('');
  const [error, setError] = useState('');
  const [verifying, setVerifying] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setVerifying(true);

    // Simulojmë një vonesë të vogël për UX
    setTimeout(() => {
      if (licenseKey.trim() === LICENSE_KEY) {
        // Verifikim lokal - pa ruajtje në localStorage
        // Thërris callback për të shfaqur SetupWizard
        onVerified();
      } else {
        setError('License key është e pasaktë. Ju lutem kontrolloni dhe provoni përsëri.');
        setVerifying(false);
      }
    }, 500);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 dark:from-dark-900 dark:to-dark-800 p-4">
      <div className="w-full max-w-md">
        <div className="card-premium-hover p-8 animate-fade-in">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl shadow-lg mb-4">
              <Lock size={40} className="text-white" />
            </div>
            <h1 className="text-3xl font-bold text-gray-800 dark:text-gray-200 mb-2">
              Setup i Sistemit
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              Vendosni license key për të vazhduar me konfigurimin
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="form-label flex items-center gap-2 mb-2">
                <Key size={18} className="text-gray-500 dark:text-gray-400" />
                License Key
              </label>
              <input
                type="text"
                value={licenseKey}
                onChange={(e) => {
                  setLicenseKey(e.target.value);
                  setError('');
                }}
                className={`input-premium w-full ${
                  error ? 'border-red-500 dark:border-red-500' : ''
                }`}
                placeholder="Shkruani license key..."
                disabled={verifying}
                autoFocus
              />
              {error && (
                <div className="mt-2 flex items-center gap-2 text-red-600 dark:text-red-400 text-sm animate-fade-in">
                  <AlertCircle size={16} />
                  <span>{error}</span>
                </div>
              )}
            </div>

            <button
              type="submit"
              disabled={verifying || !licenseKey.trim()}
              className="btn-primary w-full flex items-center justify-center gap-2 py-3 text-base font-semibold shadow-lg hover:shadow-xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {verifying ? (
                <>
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  Po verifikohet...
                </>
              ) : (
                <>
                  Verifiko dhe Vazhdo
                  <ArrowRight size={20} />
                </>
              )}
            </button>
          </form>

          {/* Info */}
          <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
            <p className="text-sm text-blue-700 dark:text-blue-300 text-center">
              <strong>Shënim:</strong> Kjo është faqja e setup-it për instalimin e parë të sistemit.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SetupLicense;

